import { Trans, useTranslation } from 'next-i18next'

import FooterAppBanner from '@/components/shared/global-footer/footer-app-banner/FooterAppBanner'
import { FooterBadges } from '@/components/shared/global-footer/footer-badges'
import { FooterLinks } from '@/components/shared/global-footer/footer-links'
import {
  CopyrightContainer,
  CopyrightSymbol,
  CopyrightText,
  FooterContainer,
  SrOnlyHeading,
} from '@/components/shared/global-footer/styled'
import { TRANSLATION_KEYS } from '@/constants/localization'

export type GlobalFooterProps = {
  mobileHidden?: boolean
  shouldHideAppBanner?: boolean
}

export const GlobalFooter = ({
  mobileHidden = false,
  shouldHideAppBanner = false,
}: GlobalFooterProps) => {
  const { t } = useTranslation(TRANSLATION_KEYS.GLOBAL_FOOTER)

  return (
    <FooterContainer
      $mobileHidden={mobileHidden}
      aria-labelledby="footerAccessibilityLabel"
      id="footer"
    >
      {shouldHideAppBanner ? null : <FooterAppBanner />}

      <SrOnlyHeading id="footerAccessibilityLabel">{t('accessibility_label')}</SrOnlyHeading>
      <FooterLinks />
      <FooterBadges />

      <CopyrightContainer>
        <CopyrightText>
          <Trans
            i18nKey="global_footer:copyright.text"
            values={{ currentYear: new Date().getFullYear() }}
            components={{
              copyrightSymbol: <CopyrightSymbol />,
            }}
          />
        </CopyrightText>
        <CopyrightText>{t('global_footer:copyright.fine_print')}</CopyrightText>
      </CopyrightContainer>
    </FooterContainer>
  )
}
